// extracted by mini-css-extract-plugin
module.exports = {"container":"wavy-box_container__AQHky","sqBtm":"wavy-box_sqBtm__IMxOk","sqBtmBg":"wavy-box_sqBtmBg__3TBTp"};